/**
 * CSRF Token Utility
 * Handles CSRF token retrieval and inclusion in requests
 */

let csrfTokenCache = null;

/**
 * Get CSRF token from response header
 * Should be called after any API response to update token cache
 * @param {Response} response - Fetch response object
 */
export function extractCSRFToken(response) {
  const token = response.headers.get('X-CSRF-Token');
  if (token) {
    csrfTokenCache = token;
  }
  return token || csrfTokenCache;
}

/**
 * Get cached CSRF token
 * @returns {string|null} - CSRF token or null
 */
export function getCSRFToken() {
  return csrfTokenCache;
}

/**
 * Clear CSRF token cache
 */
export function clearCSRFToken() {
  csrfTokenCache = null;
}

/**
 * Add CSRF token to fetch options
 * @param {Object} options - Fetch options
 * @returns {Object} - Updated fetch options with CSRF token
 */
export function addCSRFToken(options = {}) {
  const token = getCSRFToken();
  if (!token) return options;
  
  const headers = {
    ...options.headers,
    'X-CSRF-Token': token
  };
  
  return {
    ...options,
    headers
  };
}

